import { NgModule } from '@angular/core';

import { routing, appRoutingProviders } from './imported-csv.routing.';
import { ImportedCsvComponent } from './imported-csv.component';

@NgModule({
  declarations: [
    ImportedCsvComponent
  ],
  imports: [
    routing
  ],
  providers: [
    appRoutingProviders,
  ]
})
export class ImportedCsvModule { }
